module.exports = __webpack_public_path__ + "static/media/account.98acc124.png";